import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';

export interface FeedbackAttachment {
  fileUrl: string;
  fileName: string;
  urlType: string;
}

export interface FeedbackItem {
  feedbackId: number;
  message: string;
  createdAt: string;
  updatedAt: string;
  attachments: FeedbackAttachment[];
  systemResponse: string | null;
}

export interface FeedbackListBody {
  feedbackList: FeedbackItem[];
  maxPageNumber: number;
}

// Feedback — authenticated parent-portal only (see the API reference this
// was built from: the public/pre-login submit path under
// api/v3/public/feedback is deliberately out of scope here, since this
// component only ever renders inside the logged-in ParentLoginComponent
// shell, same as every other parent-* feature). No rating/category/status
// concept anywhere — just a free-text message, optional attachments, and an
// optional systemResponse from the school.
@Injectable({ providedIn: 'root' })
export class ParentFeedbackService {

  private base = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) { }

  private authHeaders(): HttpHeaders | undefined {
    const raw = localStorage.getItem('authToken');
    if (!raw) { return undefined; }
    try {
      return new HttpHeaders().append('authToken', JSON.parse(raw));
    } catch {
      return new HttpHeaders().append('authToken', raw);
    }
  }

  getFeedbackList(page: number, limit: number) {
    return this.http.get(`${this.base}/get/feedback`, {
      params: { page: String(page), limit: String(limit) },
      headers: this.authHeaders(),
    });
  }

  submitFeedback(formData: FormData) {
    return this.http.post(`${this.base}/feedback`, formData, {
      headers: this.authHeaders(),
    });
  }
}
